/*
 *   File : left-navigation.js
 *   Author : https://evoqins.com
 *   Description : Left navigation component
 *   Integrations : NA
 *   Version : 1.0.0
*/


import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

//Custom style
import styles from "../../Style/Component/left-sidebar.module.scss";

const LEFT_ITEMS = [
    {
        image_active: require('../../Assets/Images/Home/home.svg').default,
        image_inactive: require('../../Assets/Images/Home/home-inactive.svg').default,
        label: "Corridor config",
        path: "/corridor-config",
        child_path: [],
    },
    {
        image_active: require('../../Assets/Images/Home/field-master-active.svg').default,
        image_inactive: require('../../Assets/Images/Home/field-master-inactive.svg').default,
        label: "Field master",
        path: "/field-master",
        child_path: [],
    },
    {
        image_active: require('../../Assets/Images/Home/corridor-master.svg').default,
        image_inactive: require('../../Assets/Images/Home/corridor-master-inactive.svg').default,
        label: "Corridor master",
        path: "/corridor-details",
        child_path: ["/field-details"],
    },
    {
        image_active: require('../../Assets/Images/Home/upload-download-active.png'),
        image_inactive: require('../../Assets/Images/Home/upload-download.png'),
        label: "Upload",
        path: "/upload",
        child_path: [],
    },
];


const LeftNavigationWidget = (props) => {

    const navigate = useNavigate();
    const location = useLocation();

    const [hover, setHover] = useState(null);

    // handle tab 
    const _handleTabChange = (data) => {
        navigate(data.path);

        if (props.type === "offcanvas") {
            props.handleCloseOffCanvas();
        }
    }

    return (
        <div className='e-bg-white position-sticky top-0 left-0 min-h-100vh transition'>
            <div className='text-center pt-4  pb-3'>
                <img src={require("../../Assets/Images/Login/logo.svg").default}
                    draggable={false}
                    className={`${props.toggle === false ? 'w-64px' : 'w-60'} cursor-pointer  transition`}
                    alt='logo'
                    onClick={() => {
                        navigate("/corridor-config")
                        if (props.type === "offcanvas") {
                            props.handleCloseOffCanvas();
                        }
                    }} />
            </div>
            <div className={`mt-2 pt-4 pe-3 ps-3 transition max-h-zoom-100vh overflow-scroll ${styles.e_left_nav_scroll} ${!props.toggle && 'text-center'}`}>

                <>
                    {/* Navigation list for super admin */}
                    {LEFT_ITEMS.map((data, key) => (
                        <div key={key}>
                            {props.toggle === false ?
                                <div className='d-flex justify-content-center'>
                                    <div className={`${data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) ?
                                        `${styles.e_tab_active_toggle}` : `${styles.e_tab_toggle} `} margin-12px-bottom text-center transition padding-12px-tb px-3 cursor-pointer e-border-radius-8 `}
                                        onClick={() => _handleTabChange(data)}
                                        onMouseOver={() => setHover(data.path)}
                                        onMouseLeave={() => setHover(null)}>
                                        <img draggable={false} src={data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) || hover === data.path ?
                                            data.image_active : data.image_inactive}
                                            className=''
                                            width={20}
                                            alt='Icon'
                                        />
                                    </div>
                                </div>
                                :
                                <div className={`${data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) ?
                                    `${styles.e_tab_active}` : `${styles.e_tab} `} margin-12px-bottom transition cursor-pointer e-display-flex gap-0-8 e-border-radius-8 padding-12px-lr py-2`}
                                    onClick={() => _handleTabChange(data)}
                                    onMouseOver={() => setHover(data.path)}
                                    onMouseLeave={() => setHover(null)} >
                                    <img draggable={false} src={data.path === location.pathname || data.child_path.some(path => location.pathname.includes(path)) || hover === data.path ?
                                        data.image_active : data.image_inactive}
                                        className=''
                                        width={20}
                                        alt='Icon'
                                    />

                                    <p className='transition e-text-rich-black-light mb-0 e-alt-font-noto-sans e-font-16 e-font-weight-400 line-height-20px'>
                                        {data.label}
                                    </p>
                                </div>
                            }
                        </div>
                    ))}
                </>

            </div>
        </div>
    )
}

export default LeftNavigationWidget;